import CompanyRecord from 'records/company';
import { collectionReducer } from 'utils/reducerGenerator';
import { createSymbols } from 'utils/helpers';

export const {
    ADD_BOOST,
    ADD_BOOST_FAIL,
    ADD_BOOST_SUCCESS,
} = createSymbols([
    'ADD_BOOST',
    'ADD_BOOST_FAIL',
    'ADD_BOOST_SUCCESS',
]);

export const { reducer, types } = collectionReducer({
    namespace: 'COMPANY',
    transformer: CompanyRecord,
});

export default reducer;
